import __request__ from "routing/request";
export function getAll(requestOptions) {
  return __request__("GET", "/system/codecs/types/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
